import { __decorate } from "tslib";
import { Route } from '../core';
import config from '@api/config';
var CbuCheckout = /*@__PURE__*/ (function () {
    function CbuCheckout() {
    }
    CbuCheckout.post = function (response) {
        return response;
    };
    CbuCheckout = __decorate([
        Route(config.CBU_BASKET_ENDPOINT, true)
    ], CbuCheckout);
    return CbuCheckout;
}());
export { CbuCheckout };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/cbu-checkout.ts
// module id = null
// module chunks = 